import { useCallback, useState } from "react"
import { Button, Icon, IconButton, Stack, Typography, SelectorPaper, BasketButton } from "@tm/components"
import { useLocalization } from "@tm/localization"

type OwnArticlesSelectionProps = {
    selectedIds: string[]
    allSelected: boolean
    onSelectAll(): void
    onUnselectAll(): void
    onDeleteSelected(): void
    onAddToBasket(): Promise<void>
    itemsType: "article" | "repair-time"
}

export function OwnArticlesSelection({
    selectedIds,
    allSelected,
    onSelectAll,
    onUnselectAll,
    onDeleteSelected,
    onAddToBasket,
    itemsType,
}: OwnArticlesSelectionProps) {
    const { translateText } = useLocalization()

    const [isBeingAddedToBasket, setIsBeingAddedToBasket] = useState(false)

    const handleDelete = useCallback(() => {
        onDeleteSelected()
    }, [onDeleteSelected])

    const handleAddToBasket = useCallback(async () => {
        setIsBeingAddedToBasket(true)
        await onAddToBasket()
        setIsBeingAddedToBasket(false)
    }, [selectedIds, onAddToBasket])

    if (!selectedIds.length) {
        return null
    }

    return (
        <SelectorPaper sx={{ mt: 2 }}>
            <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="label">
                    {translateText(701)}: {selectedIds.length} {translateText(479)}
                </Typography>

                <Button size="small" onClick={allSelected ? onUnselectAll : onSelectAll}>
                    {translateText(allSelected ? 703 : 702)}
                </Button>

                <IconButton size="small" title={translateText(624)} onClick={handleDelete}>
                    <Icon name="delete" size="inherit" />
                </IconButton>
                <BasketButton
                    title={itemsType === "article" ? translateText(937) : translateText(916)}
                    onClick={handleAddToBasket}
                    disabled={isBeingAddedToBasket}
                    size="small"
                />
                <Button color="primary" startIcon={<Icon name="cancel-x" />} size="large" title={translateText(317)} onClick={onUnselectAll} />
            </Stack>
        </SelectorPaper>
    )
}
